import React, { useEffect, useState } from "react";
import classes from "./ContentBody.module.css";
// import { Chart } from "chart.js/auto";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
// import Select from "react-select";
import CustomChart from "../charts/customChart";
import "../../assets/css/selectDropdownCustom.css";
import { BiTimeFive } from "react-icons/bi";
import { AiOutlineLink } from "react-icons/ai";

const data = [
  { label: 2010, data: 10 },
  { label: 2011, data: 20 },
  { label: 2012, data: 15 },
  { label: 2013, data: 25 },
  { label: 2014, data: 22 },
  { label: 2015, data: 30 },
];

const data1 = [
  { label: 1, data: 35 },
  { label: 2, data: 18 },
  { label: 3, data: 15 },
  { label: 4, data: 35 },
  { label: 5, data: 40 },
  { label: 6, data: 20 },
  { label: 7, data: 30 },
  { label: 8, data: 25 },
  { label: 9, data: 22 },
  { label: 10, data: 20 },
  { label: 11, data: 45 },
  { label: 12, data: 35 },
  { label: 13, data: 55 },
  { label: 14, data: 55 },
  { label: 15, data: 55 },
  { label: 16, data: 55 },
  { label: 17, data: 55 },
  { label: 18, data: 55 },
  { label: 19, data: 55 },
  { label: 20, data: 55 },
  { label: 21, data: 55 },
  { label: 22, data: 55 },
  { label: 23, data: 55 },
  { label: 24, data: 55 },
  { label: 25, data: 55 },
  { label: 26, data: 55 },
  { label: 27, data: 55 },
  { label: 28, data: 55 },
  { label: 29, data: 55 },
  { label: 30, data: 55 },
  { label: 31, data: 55 },
];

const data2 = [
  {
    first: [30, 35, 30, 50, 30, 50, 40, 45],
    second: [20, 25, 20, 15, 25, 22, 24, 20],
    third: [20, 21, 22, 21, 22, 15, 17, 20],
  },
  {
    first: [35, 35, 40, 30, 38, 40, 50, 38],
    second: [30, 20, 35, 20, 25, 30, 25, 20],
    third: [35, 40, 40, 30, 38, 50, 42, 32],
  },
  {
    first: [35, 40, 40, 30, 38, 32, 42, 32],
    second: [20, 25, 35, 25, 22, 21, 21, 38],
    third: [30, 35, 40, 30, 38, 50, 42, 32],
  },
  {
    first: [35, 40, 30, 38, 32, 42, 30, 35],
    second: [25, 30, 35, 25, 20, 22, 25, 38],
    third: [35, 35, 40, 30, 38, 40, 30, 38],
  },
];

const options1 = {
  scales: {
    x: {
      display: false,
    },
    y: {
      display: false,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
  responsive: true,
};

const activity1 = {
  responsive: true,
  legend: {
    display: false,
  },
  scales: {
    y: {
      grid: {
        color: "rgba(233,236,255,1)",
        drawBorder: true,
      },
      ticks: {
        fontColor: "#6E6E6E",
        max: 60,
        min: 0,
        stepSize: 20,
      },
    },
    x: {
      barPercentage: 0.3,

      grid: {
        display: false,
        zeroLineColor: "transparent",
      },
      ticks: {
        stepSize: 20,
        fontColor: "#6E6E6E",
        fontFamily: "Nunito, sans-serif",
      },
    },
  },
  tooltips: {
    // mode: "index",
    // intersect: false,
    // titleFontColor: "#888",
    // bodyFontColor: "#555",
    // titleFontSize: 12,
    // bodyFontSize: 15,
    // backgroundColor: "rgba(255,255,255,1)",
    // displayColors: true,
    // xPadding: 10,
    // yPadding: 7,
    // borderColor: "rgba(220, 220, 220, 1)",
    // borderWidth: 1,
    // caretSize: 6,
    // caretPadding: 10,
  },
  plugins: {
    legend: {
      display: false,
    },
  },
};

const activityOption = {
  responsive: true,
  maintainAspectRatio: false,
  elements: {
    point: {
      radius: 0,
    },
  },
  legend: false,

  scales: {
    y: {
      grid: {
        color: "rgba(89, 59, 219,0.1)",
        drawBorder: true,
      },
      ticks: {
        fontSize: 14,
        fontColor: "#6E6E6E",
        fontFamily: "Poppins",
      },
    },
    x: {
      //FontSize: 40,
      grid: {
        display: false,
        zeroLineColor: "transparent",
      },
      ticks: {
        fontSize: 14,
        stepSize: 5,
        fontColor: "#6E6E6E",
        fontFamily: "Poppins",
      },
    },
  },
  tooltips: {
    enabled: false,
    mode: "index",
    intersect: false,
    titleFontColor: "#888",
    bodyFontColor: "#555",
    titleFontSize: 12,
    bodyFontSize: 15,
    backgroundColor: "rgba(256,256,256,0.95)",
    displayColors: true,
    xPadding: 10,
    yPadding: 7,
    borderColor: "rgba(220, 220, 220, 0.9)",
    borderWidth: 2,
    caretSize: 6,
    caretPadding: 10,
  },
  plugins: {
    legend: {
      align: "start",
      title: {
        position: "start",
      },
      display: false,
    },
  },
};

const options = {
  dots: false,
  autoWidth: true,
  margin: 20,
  loop: true,
};

const ContentBody = (props) => {
  const { topStats, latestRegistration, regChart } = props;
  const [test, setTest] = useState(latestRegistration);
  const [newTopStates, setTopStates] = useState(topStats);

  const [option1Data, setOption1Data] = useState({
    labels: data.map((row) => row.label),
    datasets: [
      {
        data: [100, 300, 200, 400, 100, 400],
        fill: false,
        tension: 0.2,
        borderWidth: 6,
        pointRadius: 0,
        pointStyle: "line",
        borderColor: "#F93A0B",
      },
    ],
  });
  const [option2Data, setOption2Data] = useState({
    labels: data.map((row) => row.label),
    datasets: [
      {
        data: data.map((row) => row.data),
        fill: false,
        tension: 0.2,
        borderWidth: 6,
        pointRadius: 0,
        pointStyle: "line",
        borderColor: "#3385D6",
      },
    ],
  });
  const [option3Data, setOption3Data] = useState({
    labels: data.map((row) => row.label),
    datasets: [
      {
        data: data.map((row) => row.data),
        fill: false,
        tension: 0.2,
        borderWidth: 6,
        pointRadius: 0,
        pointStyle: "line",
        borderColor: "#145650",
      },
    ],
  });
  const [option4Data, setOption4Data] = useState({
    labels: data.map((row) => row.label),
    datasets: [
      {
        data: data.map((row) => row.data),
        fill: false,
        tension: 0.2,
        borderWidth: 6,
        pointRadius: 0,
        pointStyle: "line",
        borderColor: "#B723AD",
      },
    ],
  });
  const {
    totalUsers,
    totalVerifiedUsers,
    totalVerifiedUserChart,
    thisWeekTotal,
    thisWeekAllDates,
    thisWeekWithDates,
    lastWeekTotal,
    thisMonthTotal,
    thisMonthAllDates,
    thisMonthWithDates,
    lastMonthTotal,
    lastSixMonthDates,
    lastSixMonthWithDates,
  } = topStats;
  const {
    monthWithDates,
    thisMonthAllDatesChart,
    weeklyUsers,
    last14days_registrations,

    last14WeeksRange,
    last14DaysRange,

    lastlast12MonthDates,
    MonthlyPageViews_filtered,
    DailyPageViews_filtered,
    weeklyPageViews,
  } = regChart;

  const getPercentageIncrease = (numA, numB) => {
    if (numB === 0) {
      return numA * 100;
    } else {
      return ((numA - numB) / numB) * 100;
    }
  };

  const [actv1, setFreq1] = useState({
    chartFrequency: null,
    chartFrequency1: null,
    chartFrequency2: "active",
  });
  const [actv2, setFreq2] = useState({
    chartFrequency: null,
    chartFrequency1: null,
    chartFrequency2: "active",
  });
  const [chart, setChart] = useState({
    labels: data1.map((data) => data.label),
    datasets: [
      {
        data: data1.map((data) => data.data),
        borderColor: "var(--primary)",
        borderWidth: "0",
        barThickness: 11,
        backgroundColor: "#F73A0B",
        minBarLength: 10,
      },
    ],
  });

  const [vacancyChart, setVacancyChart] = useState({
    labels: lastlast12MonthDates,
    datasets: [
      {
        label: "Application Sent",
        backgroundColor: "rgba(82, 177, 65, 0)",
        borderColor: "#3FC55E",
        data: MonthlyPageViews_filtered,
        borderWidth: 6,
        tension: 0.4,
        position: "center",
      },
    ],
  });

  const chart1Frequency1 = (freq) => {
    setFreq1({
      chartFrequency: "active",
      chartFrequency1: null,
      chartFrequency2: null,
    });
    setChart({
      labels: last14DaysRange,
      datasets: [
        {
          data: last14days_registrations,
          borderColor: "var(--primary)",
          borderWidth: "0",
          barThickness: 11,
          backgroundColor: "#F73A0B",
          minBarLength: 10,
        },
      ],
    });
  };
  const chart1Frequency2 = (freq) => {
    setFreq1({
      chartFrequency: null,
      chartFrequency1: "active",
      chartFrequency2: null,
    });
    setChart({
      labels: last14WeeksRange,
      datasets: [
        {
          data: weeklyUsers,
          borderColor: "var(--primary)",
          borderWidth: "0",
          barThickness: 11,
          backgroundColor: "#F73A0B",
          minBarLength: 10,
        },
      ],
    });
  };
  const chart1Frequency3 = (freq) => {
    setFreq1({
      chartFrequency: null,
      chartFrequency1: null,
      chartFrequency2: "active",
    });
    setChart({
      labels: lastlast12MonthDates,
      datasets: [
        {
          data: monthWithDates,
          borderColor: "var(--primary)",
          borderWidth: "0",
          barThickness: 11,
          backgroundColor: "#F73A0B",
          minBarLength: 10,
        },
      ],
    });
  };

  const chart2Frequency1 = (freq) => {
    setFreq2({
      chartFrequency: "active",
      chartFrequency1: null,
      chartFrequency2: null,
    });
    setVacancyChart({
      labels: last14DaysRange,
      datasets: [
        {
          label: "Application Sent",
          backgroundColor: "rgba(82, 177, 65, 0)",
          borderColor: "#3FC55E",
          data: DailyPageViews_filtered,
          borderWidth: 6,
          tension: 0.4,
          position: "center",
        },
      ],
    });
  };
  const chart2Frequency2 = (freq) => {
    setFreq2({
      chartFrequency: null,
      chartFrequency1: "active",
      chartFrequency2: null,
    });
    setVacancyChart({
      labels: last14WeeksRange,
      datasets: [
        {
          label: "Application Sent",
          backgroundColor: "rgba(82, 177, 65, 0)",
          borderColor: "#3FC55E",
          data: weeklyPageViews,
          borderWidth: 6,
          tension: 0.4,
          position: "center",
        },
      ],
    });
  };
  const chart2Frequency3 = (freq) => {
    setFreq2({
      chartFrequency: null,
      chartFrequency1: null,
      chartFrequency2: "active",
    });
    setVacancyChart({
      labels: lastlast12MonthDates,
      datasets: [
        {
          label: "Application Sent",
          backgroundColor: "rgba(82, 177, 65, 0)",
          borderColor: "#3FC55E",
          data: MonthlyPageViews_filtered,
          borderWidth: 6,
          tension: 0.4,
          position: "center",
        },
      ],
    });
  };

  useEffect(() => {
    setTest(latestRegistration);
    setTopStates(topStats);
    let updatedData1 = { ...option1Data };
    updatedData1.labels = thisWeekAllDates;
    updatedData1.datasets[0].data = thisWeekWithDates;
    setOption1Data(updatedData1);
    let updatedData2 = { ...option2Data };
    updatedData2.labels = thisMonthAllDates;
    updatedData2.datasets[0].data = thisMonthWithDates;
    setOption2Data(updatedData2);
    let updatedData3 = { ...option3Data };
    updatedData3.labels = lastSixMonthDates;
    updatedData3.datasets[0].data = lastSixMonthWithDates;
    setOption3Data(updatedData3);
    let updatedData4 = { ...option4Data };
    updatedData4.labels = lastSixMonthDates;
    updatedData4.datasets[0].data = totalVerifiedUserChart;
    setOption4Data(updatedData4);
    setChart({
      labels: lastlast12MonthDates,
      datasets: [
        {
          data: monthWithDates,
          borderColor: "var(--primary)",
          borderWidth: "0",
          barThickness: 11,
          backgroundColor: "#F73A0B",
          minBarLength: 10,
        },
      ],
    });
    setVacancyChart({
      labels: lastlast12MonthDates,
      datasets: [
        {
          label: "Application Sent",
          backgroundColor: "rgba(82, 177, 65, 0)",
          borderColor: "#3FC55E",
          data: MonthlyPageViews_filtered,
          borderWidth: 6,
          tension: 0.4,
          position: "center",
        },
      ],
    });
  }, [
    latestRegistration,
    monthWithDates,
    thisMonthAllDatesChart,
    weeklyUsers,
    last14days_registrations,
    topStats,
  ]);

  const width = {
    width: 80,
    height: 80,
  };
  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="row separate-row">
                    <div className="col-sm-6">
                      <div className="job-icon pb-4 d-flex justify-content-between">
                        <div>
                          <div className="d-flex align-items-center mb-1">
                            <h2 className="mb-0">{thisWeekTotal}</h2>
                            <span className="text-success ms-3">
                              {getPercentageIncrease(
                                thisWeekTotal,
                                lastWeekTotal
                              ).toFixed(2)}
                              %
                            </span>
                          </div>
                          <span className="fs-14 d-block mb-2">
                            Weekly Users
                          </span>
                        </div>
                        <div style={{ width: "170px", height: "80px" }}>
                          <CustomChart
                            id="interviewSchedules"
                            width="200"
                            height="100"
                            data={option1Data}
                            options={options1}
                            type="line"
                            borderColor="rgb(75, 192, 192)"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="job-icon pb-4 pt-4 pt-sm-0 d-flex justify-content-between">
                        <div>
                          <div className="d-flex align-items-center mb-1">
                            <h2 className="mb-0">{thisMonthTotal}</h2>
                            <span className="text-success ms-3">
                              {getPercentageIncrease(
                                thisMonthTotal,
                                lastMonthTotal
                              ).toFixed(2)}
                              %
                            </span>
                          </div>
                          <span className="fs-14 d-block mb-2">
                            Monthly Users
                          </span>
                        </div>
                        <div style={{ width: "170px", height: "80px" }}>
                          <CustomChart
                            id="applicationSent"
                            width="200"
                            height="100"
                            data={option2Data}
                            options={options1}
                            type="line"
                            borderColor="rgb(20, 86, 80)"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="job-icon pt-4 pb-sm-0 pb-4 pe-3 d-flex justify-content-between">
                        <div>
                          <div className="d-flex align-items-center mb-1">
                            <h2 className="mb-0">{totalUsers}</h2>
                          </div>
                          <span className="fs-14 d-block mb-2">
                            Total Users
                          </span>
                        </div>
                        <div style={{ width: "170px", height: "80px" }}>
                          <CustomChart
                            id="profileViewed"
                            width="200"
                            height="100"
                            data={option3Data}
                            options={options1}
                            type="line"
                            borderColor="rgb(51, 133, 214)"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="job-icon pt-4  d-flex justify-content-between">
                        <div>
                          <div className="d-flex align-items-center mb-1">
                            <h2 className="mb-0">{totalVerifiedUsers}</h2>
                          </div>
                          <span className="fs-14 d-block mb-2">
                            Verified Users
                          </span>
                        </div>
                        <div style={{ width: "170px", height: "80px" }}>
                          <CustomChart
                            id="unReadMessages"
                            width="200"
                            height="100"
                            data={option4Data}
                            options={options1}
                            type="line"
                            borderColor="rgb(183, 35, 173)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="row">
                <div className="col-xl-12">
                  <div className="card" id="user-activity1">
                    <div className="card-header border-0 pb-0">
                      <h4 className="fs-20 mb-1">Users Registration</h4>
                      <div className="card-action coin-tabs mt-3 mt-sm-0">
                        <ul className="nav nav-tabs" role="tablist">
                          <li className="nav-item">
                            <button
                              className={`nav-link ${actv1.chartFrequency}`}
                              onClick={() => {
                                chart1Frequency1(1);
                              }}
                            >
                              Daily
                            </button>
                          </li>
                          <li className="nav-item">
                            <button
                              className={`nav-link ${actv1.chartFrequency1}`}
                              onClick={() => {
                                chart1Frequency2(2);
                              }}
                            >
                              Weekly
                            </button>
                          </li>
                          <li className="nav-item">
                            <button
                              className={`nav-link ${actv1.chartFrequency2}`}
                              onClick={() => {
                                chart1Frequency3(3);
                              }}
                            >
                              Monthly
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="tab-content" id={classes.myTabContent}>
                        <div
                          className="tab-pane fade show active"
                          id={classes.monthly1}
                        >
                          <CustomChart
                            id="activity1"
                            width="200"
                            height="70"
                            data={chart}
                            options={activity1}
                            type="bar"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="row">
                <div className="col-xl-12">
                  <div className="card " id="user-activity">
                    <div className="card-header border-0 pb-0 flex-wrap">
                      <h4 className="fs-20 mb-1">Page Visits</h4>
                      <div className="card-action coin-tabs mt-3 mt-sm-0">
                        <ul className="nav nav-tabs" role="tablist">
                          <li className="nav-item">
                            <button
                              className={`nav-link ${actv2.chartFrequency}`}
                              onClick={() => {
                                chart2Frequency1(1);
                              }}
                            >
                              Daily
                            </button>
                          </li>
                          <li className="nav-item">
                            <button
                              className={`nav-link ${actv2.chartFrequency1}`}
                              onClick={() => {
                                chart2Frequency2(2);
                              }}
                            >
                              Weekly
                            </button>
                          </li>
                          <li className="nav-item">
                            <button
                              className={`nav-link ${actv2.chartFrequency2}`}
                              onClick={() => {
                                chart2Frequency3(3);
                              }}
                            >
                              Monthly
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="tab-content">
                        <div
                          className="tab-pane fade show active"
                          id={classes.daily}
                        >
                          <CustomChart
                            id="activity"
                            width="200"
                            height="70"
                            data={vacancyChart}
                            options={activityOption}
                            type="line"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {latestRegistration && latestRegistration.length > 0 && (
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header pb-0 border-0 flex-wrap">
                    <h4 className="fs-20 mb-3">Latest User Registration</h4>
                    <div style={{ display: "flex" }}>
                      <a href="/admin/users" className="btn btn-primary btn-sm">
                        Show All
                      </a>
                    </div>
                  </div>
                  <div className="card-body">
                    <OwlCarousel className="owl-theme" {...options}>
                      {latestRegistration &&
                        latestRegistration.length > 0 &&
                        latestRegistration.map((val) => {
                          return (
                            <div className="item" key={val._id}>
                              <div className="jobs">
                                <div className="text-center">
                                  <div className="d-flex justify-content-center">
                                    <img
                                      style={width}
                                      src={
                                        process.env.REACT_APP_IMAGE_URL +
                                        "profile-images/thumbnail_96/" +
                                        val.profile
                                      }
                                      alt={val.name}
                                    />
                                  </div>
                                  <h4 className="mb-0">{val.name}</h4>
                                </div>
                                <div className="text-center">
                                  <span className="d-block mb-1">
                                    <AiOutlineLink />{" "}
                                    {process.env.REACT_APP_MAIN_DOMAIN}/
                                    {val.username}
                                  </span>
                                  <span>
                                    <BiTimeFive /> on {val.createDate}
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </OwlCarousel>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContentBody;
